import React, { useState } from 'react';

export const Auth = ({type}) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    phoneNumber: '',
    email: '',
    refferCode: '',
    verificationCode: ''
  });
  let inputFields = [
    { label: "Username", placeholder: "4-15 char, allow number" },
    { label: "Password", placeholder: "password" },
    { label: "Confirm Password", placeholder: "password" },
    { label: "Currency", placeholder: "BDT" },
    { label: "Full label", placeholder: "Full label" },
    { label: "Phone Number", placeholder: "+880 1234567899" },
    { label: "Email", placeholder: "Email" },
    { label: "Refer Code", placeholder: "Refer Code" },
    { label: "Verification Code", placeholder: "Enter 4 digit code" }
  ];
  
  if(type=="login"){
    inputFields = inputFields.slice(0,2)
  }

  return (
    <div className="min-h-screen bg-black font-custom">
      <div className=' w-full bg-bg-3  text-white font-bold text-center py-3 capitalize'>{type}</div>
       <div className='flex justify-center py-3'> 
    <img src="new_img/logo.png" alt="" width={200} /> 
    </div>
    <div className=' px-2'>
      {inputFields.map((feild, idx)=><InputFeild idx={idx}  label={feild.label} placeholder={feild.placeholder} />)}
    </div>
    <div className=' px-2'>
      <div className=" py-2 w-full rounded-md bg-[#14805e] mt-3 flex justify-center">
          <button className="font-bold text-[#d7e3f1] text-center capitalize">{type}</button>
        </div>
    </div>

        <p className=' text-center text-white mt-1'>Do you already have an account?
          <a href={type=="login"?`/signup`:"/login"} className=' text-yellow-600 inline-block ml-1'>{type=="login"?"Sign Up":"Login"}</a>
        </p>
    </div>
  );
};

const InputFeild = ({label, placeholder,idx})=>{
  return  <div className={`${idx==4||idx==8?" mt-[10px]":""} bg-bg-3 flex gap-3 p-[18px] border-b-[0.2px] border-brd2 w-full items-center font-custom rounded-t-sm`}>
    <div className=' text-white w-[30%] text-sm'>
      {label}
    </div>
    <div className=' w-full'>
      <input type="text" className=' text-base p-1 text-white bg-transparent placeholder-[#7e7d7d] outline-none' placeholder={placeholder} />
    </div>
  </div>
}